import "./TheGarden.module.css";
import MainNavigation from "@/reusable_sections/Header";
import SacredMoments from "./sections/SacredMoments";
import OutboundCommunicationDetails from "./sections/OutboundCommunicationDetails";
import TravelAndStay from "./sections/TravelAndStay";
import Footer from "@/reusable_sections/Footer";
export default function TheGardenPage() {
  return <div>
      <MainNavigation />
      <SacredMoments />
      <OutboundCommunicationDetails />
      <TravelAndStay />
      <Footer />
    </div>;
}